import { inmunetApi } from '../../../../../api';

export const getSuscripcion = async() => {

    try {

        const { data } = await inmunetApi.get('/suscripcion');

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener los datos';

        return data;

    } catch (error) {

        throw new Error(error);

    }

};